import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"overflow":"hidden","width":"560px"} }
const _hoisted_2 = { class: "field-group q-mt-sm" }
const _hoisted_3 = {
  class: "field-group__row no-wrap q-mt-xs justify-between",
  style: {"align-items":"end"}
}
const _hoisted_4 = { class: "bold-name q-mr-xs" }
const _hoisted_5 = {
  class: "field-group__row no-wrap q-mt-xs justify-between",
  style: {"align-items":"end"}
}
const _hoisted_6 = { class: "bold-name q-mr-xs" }
const _hoisted_7 = {
  class: "field-group__row no-wrap q-mt-xs justify-between",
  style: {"align-items":"end"}
}
const _hoisted_8 = { class: "bold-name q-mr-xs" }
const _hoisted_9 = {
  class: "field-group__row no-wrap q-mt-xs justify-between",
  style: {"align-items":"end"}
}
const _hoisted_10 = { class: "bold-name q-mr-xs" }
const _hoisted_11 = {
  class: "field-group__row no-wrap q-mt-xs justify-between",
  style: {"align-items":"end"}
}
const _hoisted_12 = { class: "bold-name q-mr-xs" }
const _hoisted_13 = {
  class: "field-group__row no-wrap q-mt-xs justify-between",
  style: {"align-items":"end"}
}
const _hoisted_14 = { class: "bold-name q-mr-xs" }
const _hoisted_15 = {
  class: "field-group__row no-wrap q-mt-xs justify-between",
  style: {"align-items":"end"}
}
const _hoisted_16 = { class: "bold-name q-mr-xs" }
const _hoisted_17 = {
  class: "field-group__row no-wrap q-mt-xs justify-between",
  style: {"align-items":"end"}
}
const _hoisted_18 = { class: "bold-name q-mr-xs" }
const _hoisted_19 = {
  class: "field-group__row no-wrap q-mt-xs justify-between",
  style: {"align-items":"end"}
}
const _hoisted_20 = { class: "bold-name q-mr-xs" }
const _hoisted_21 = {
  class: "field-group__row no-wrap q-mt-xs justify-between",
  style: {"align-items":"end"}
}
const _hoisted_22 = { class: "bold-name q-mr-xs" }
const _hoisted_23 = {
  class: "field-group__row no-wrap q-mt-xs justify-between",
  style: {"align-items":"end"}
}
const _hoisted_24 = { class: "bold-name q-mr-xs" }
const _hoisted_25 = {
  class: "field-group__row no-wrap q-mt-xs justify-between",
  style: {"align-items":"end"}
}
const _hoisted_26 = { class: "bold-name q-mr-xs" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_native_input = _resolveComponent("native-input")!
  const _component_q_select = _resolveComponent("q-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('name_upcase')) + ":", 1),
        _createVNode(_component_native_input, {
          style: {"min-width":"200px"},
          ref: "name_input",
          "allow-line-break": false,
          modelValue: _ctx.theModel.Name,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.theModel.Name) = $event)),
          "edit-on-click": true,
          "show-border": true
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('inn')) + ":", 1),
        _createVNode(_component_native_input, {
          style: {"min-width":"200px"},
          ref: "comment_input",
          "allow-line-break": false,
          modelValue: _ctx.theModel.INN,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.theModel.INN) = $event)),
          "edit-on-click": true,
          "show-border": true
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('kpp')) + ":", 1),
        _createVNode(_component_native_input, {
          style: {"min-width":"200px"},
          ref: "comment_input",
          "allow-line-break": false,
          modelValue: _ctx.theModel.KPP,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.theModel.KPP) = $event)),
          "edit-on-click": true,
          "show-border": true
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('personal_account')) + ":", 1),
        _createVNode(_component_native_input, {
          style: {"min-width":"200px"},
          ref: "comment_input",
          "allow-line-break": false,
          modelValue: _ctx.theModel.Account,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.theModel.Account) = $event)),
          "edit-on-click": true,
          "show-border": true
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t('bank_account')) + ":", 1),
        _createVNode(_component_native_input, {
          style: {"min-width":"200px"},
          ref: "comment_input",
          "allow-line-break": false,
          modelValue: _ctx.theModel.bankAccount,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.theModel.bankAccount) = $event)),
          "edit-on-click": true,
          "show-border": true
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t('bank_name')) + ":", 1),
        _createVNode(_component_native_input, {
          style: {"min-width":"200px"},
          ref: "comment_input",
          "allow-line-break": false,
          modelValue: _ctx.theModel.bankName,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.theModel.bankName) = $event)),
          "edit-on-click": true,
          "show-border": true
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$t('bik')) + ":", 1),
        _createVNode(_component_native_input, {
          style: {"min-width":"200px"},
          ref: "comment_input",
          "allow-line-break": false,
          modelValue: _ctx.theModel.BIK,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.theModel.BIK) = $event)),
          "edit-on-click": true,
          "show-border": true
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.$t('bank_corr_account')) + ":", 1),
        _createVNode(_component_native_input, {
          style: {"min-width":"200px"},
          ref: "comment_input",
          "allow-line-break": false,
          modelValue: _ctx.theModel.corrAccount,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.theModel.corrAccount) = $event)),
          "edit-on-click": true,
          "show-border": true
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.$t('legal_address')) + ":", 1),
        _createVNode(_component_native_input, {
          style: {"min-width":"200px"},
          ref: "comment_input",
          "allow-line-break": false,
          modelValue: _ctx.theModel.jurAddress,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.theModel.jurAddress) = $event)),
          "edit-on-click": true,
          "show-border": true
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.$t('legal_form')) + ":", 1),
        _createVNode(_component_native_input, {
          style: {"min-width":"200px"},
          ref: "comment_input",
          "allow-line-break": false,
          modelValue: _ctx.theModel.legalUnit,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.theModel.legalUnit) = $event)),
          "edit-on-click": true,
          "show-border": true
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.$t('comment')) + ":", 1),
        _createVNode(_component_native_input, {
          style: {"min-width":"200px"},
          ref: "comment_input",
          modelValue: _ctx.theModel.Note,
          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.theModel.Note) = $event)),
          "edit-on-click": true,
          "show-border": true
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.$t('one_c_instance')) + ":", 1),
        _createVNode(_component_q_select, {
          flat: "",
          modelValue: _ctx.theModel.instance1C,
          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.theModel.instance1C) = $event)),
          style: {"min-width":"200px","padding":"0 !important"},
          class: "thin-input",
          "dropdown-icon": "expand_more",
          "fill-input": "",
          "bottom-slots": false,
          dense: "",
          outlined: "",
          "input-debounce": "500",
          "emit-value": "",
          "map-options": "",
          ref: "from_select",
          options: _ctx.instanceOptions
        }, null, 8, ["modelValue", "options"])
      ])
    ])
  ]))
}